import {api} from './base';
import {handleApiError} from './util';
import useTokenStore from './token';
import {
    AuthenticateRequest,
    AuthenticateResponseData,
    CheckResponseData,
    COOKIE_NAMES,
    LoginRequest,
    LoginResponseData,
    PasswordResetRequest,
    RegisterRequest,
} from '../types/auth';
import useUserInfoStore from "./user_info";
import {ApiResponse} from "../types/response";

export const mailAPI = async (email: string) => { //이메일 인증 코드 전송 API 호출
    try {
        const response = await api.post<ApiResponse<void>>('/auth/mail', null, {
            params: {email}
        });
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
    } catch (error) {
        handleApiError(error);
    }
};

export const changePasswordAPI = async (password: string, newPassword: string) => { //비밀번호 변경 API 호출
    try {
        await api.patch<ApiResponse<void>>('/auth/password', {password, newPassword});
    } catch (error) {
        handleApiError(error);
    }
};

export const checkAPI = async (email: string, code: string) => { //이메일 인증 API 호출
    try {
        const response = await api.get<ApiResponse<CheckResponseData>>('/auth/mail', {
            params: {email, verificationCode: code}
        });
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
    } catch (error) {
        handleApiError(error);
    }
};

export const findPasswordAPI = async (email: string, businessNumber: string): Promise<boolean> => { //비밀번호 찾기 API 호출
    try {
        const request: PasswordResetRequest = {
            email: email,
            businessNumber: businessNumber
        }
        const response = await api.patch<ApiResponse<void>>('/auth/find-pw', request);

        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return true;
    } catch (error) {
        handleApiError(error, '비밀번호 초기화 과정에서 오류가 발생했습니다.');
        return false;
    }
};

export const authenticateAPI = async (businessNumber: string, name: string, companyName: string, date: Date): Promise<AuthenticateResponseData> => { //사업자등록번호 인증 API 호출
    try {
        const formatDate = (date: Date): string => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}${month}${day}`;
        };

        const cleanBusinessNumber = businessNumber.replace(/-/g, '');
        const requestData: AuthenticateRequest = {
            businesses: [{
                b_no: cleanBusinessNumber,
                start_dt: formatDate(date),
                p_nm: name,
                b_nm: companyName
            }]
        };

        const response = await api.post<ApiResponse<AuthenticateResponseData>>('/auth/business-number', requestData);

        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '인증 과정에서 오류가 발생했습니다.');
        throw error;
    }
};

export const registerAPI = async (data: RegisterRequest, file: File): Promise<number> => { //회원가입 API 호출
    try {
        const formData = new FormData();
        const jsonBlob = new Blob([JSON.stringify(data)], {type: 'application/json'});
        formData.append('registerRequest', jsonBlob);
        formData.append('license', file);

        const response = await api.post<ApiResponse<number>>('/auth/register', formData, {
            headers: {'Content-Type': 'multipart/form-data'},
        });

        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '회원가입에 실패했습니다.');
        throw error;
    }
};

export const requestAPI = async (userId: number) => { //클라이언트 가입 요청 생성 API 호출
    try {
        const response = await api.post<ApiResponse<void>>('/request/client?userId=' + userId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
    } catch (error) {
        handleApiError(error, '회원가입에 실패했습니다.');
        throw error;
    }
}

export const loginAPI = async ({username, password}: {
    username: string;
    password: string;
}, keepLogin: boolean): Promise<LoginResponseData> => { //로그인 API 호출
    try {
        const loginRequest: LoginRequest = {username, password, keepLogin};
        const response = await api.post<ApiResponse<LoginResponseData>>('/auth/login', loginRequest);

        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }

        const {accessToken, refreshToken, role, isFirstTempLogin, id, optional} = response.data.data;

        document.cookie = `${COOKIE_NAMES.REFRESH_TOKEN}=${refreshToken}; path=/; secure; samesite=strict`;

        useTokenStore.getState().setAccessToken(accessToken);
        useUserInfoStore.getState().setUserInfo({userName: username, role});

        sessionStorage.setItem('role', role);
        sessionStorage.setItem('isFirstTempLogin', String(isFirstTempLogin));
        sessionStorage.setItem('optional', String(optional));
        sessionStorage.setItem('userId', String(id));
        console.log(optional)
        return response.data.data;
    } catch (error) {
        handleApiError(error, '로그인 중 예상치 못한 오류가 발생했습니다.');
        throw error;
    }
};
